import OperationButton from "@/components/FollowButton/operationButton";
import HBButton from "@/components/HBButton";
import HBConfirm from "@/components/HBModal/confirm";
import { useJobName } from "@/components/JobSelect/useCrowdTag";
import { MuseTag } from "@/components/Muse";
import ShareDropdown from "@/components/ShareDropdown";
import UserAvatar from "@/components/UserAvatar";
import useAppStore from "@/context/store";
import {
  followUser,
  outBlackList,
  report,
  toBlackList,
  unfollowUser,
} from "@/services";
import displayNum from "@/utils/displayNum";
import { openSettingPage } from "@/utils/gaoding";
import imageUrl from "@/utils/imageUrl";
import isDuringSpecial from "@/utils/isDuringSpecial";
import { checkLogin, openBindTelModal } from "@/utils/open";
import { Button, Dropdown, Tooltip } from "antd";
import dayjs from "dayjs";
import Link from "next/link";
import { useCallback, useMemo, useState } from "react";
import { Else, If, Then, When } from "react-if";
import { ChatModal } from "../../../Chat";
import FollowerModal from "../../../FollowerModal";
import HBIcon from "../../../HBIcon";
import HBMessage from "../../../HBMessage";
import { useLogin } from "../../../LoginModal";
import ReportModal from "../../../ReportModal";
import styles from "./index.module.less";

const isSpecialTime = isDuringSpecial();

/**
 * @param {any} user
 * @param {boolean} isMe
 * @returns {JSX.Element}
 * @constructor
 */
export default function Summary({ user, isMe }) {
  const {
    avatar,
    username,
    follower_count,
    following_count,
    urlname,
    user_id,
    avatar_url,
  } = user;
  const [following, setFollowing] = useState(user.following ?? false);
  const { config } = useAppStore(({ config }) => ({ config }));
  const [win, setWin] = useState({
    follower: false,
    chat: false,
  });
  const currentUser = useAppStore((s) => s.user);
  /**是否被拉黑 */
  const isBlocked = user.blacklisted;
  /**是否拉黑别人 */
  const [hasBlocked, setHasBlocked] = useState(user.blacked);

  //
  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(urlname) || false;
  }, [config, urlname]);

  const likesCount = useMemo(() => {
    return (
      (user?.like_count || 0) +
      (user?.boards_like_count || 0) +
      (user?.topic_like_count || 0)
    );
  }, [user]);

  const { login } = useLogin();

  const onMessageClick = useCallback(async () => {
    if (!currentUser?.user_id) {
      const result = await login({
        source_location: "用户私信",
      });
      if (!result) {
        return;
      }
    }

    await openBindTelModal();

    setWin({ ...win, chat: true });
  }, [login, currentUser, win]);

  const onFollowClick = useCallback(async () => {
    if (!currentUser?.user_id) {
      const result = await login({
        source_location: "用户关注",
      });
      if (!result) {
        return;
      }
    }
    const { err } = await followUser(urlname);
    if (err) return;
    setFollowing(true);
  }, [urlname, currentUser, login]);

  const onUnfollowClick = useCallback(async () => {
    const { err } = await unfollowUser(urlname);
    if (err) return;
    setFollowing(false);
  }, [urlname]);

  const onBlockClick = useCallback(async () => {
    const loginUserInfo = await checkLogin({
      source_location: "加入黑名单",
    });
    if (!loginUserInfo) return;

    HBConfirm.open({
      title: "提示",
      content: `加入黑名单，对方无法再关注你，并且无法给你发私信。可在「个人设置」中管理黑名单`,
      okText: "确定",
      onOk: async () => {
        const res = await toBlackList({
          item_type: 3,
          item_value: user.user_id,
        });

        if (res.err) return;
        setHasBlocked(true);
      },
    });
  }, []);

  const onUnblockClick = useCallback(async () => {
    const res = await outBlackList({
      item_type: 3,
      item_value: user.user_id,
    });
    if (res.err) return;
    setHasBlocked(false);
  }, [user?.user_id]);

  const onReportClick = useCallback(async () => {
    const loginUserInfo = await checkLogin({
      source_location: "举报用户",
    });
    if (!loginUserInfo) return;

    ReportModal.open({
      reportType: "用户",
      reportUserId: user_id,
      onOk: async (values) => {
        const { err, msg } = await report({
          type: "account",
          ...values,
          id: user_id,
        });
        if (err) {
          if (err === "already reported") {
            HBMessage.success("你已经举报过了，我们会及时处理哦，谢谢");
          } else {
            console.error("report error:", err);
            HBMessage.error("请求失败：" + msg || err.toString());
          }
        } else {
          HBMessage.success("举报成功，我们会及时处理哦，谢谢");
        }
      },
    });
  }, [user_id]);

  const jobName = useJobName(user);

  const SummaryBlock2Elements = useCallback(() => {
    const elements = [];

    // 徽章荣誉部分
    if (isOfficial) {
      elements.push(
        <div className={styles.honor}>
          <div className={styles.item}>
            <div className={styles.icon}>
              <span className={styles.official} title="花瓣官方"></span>
            </div>
            <div className={styles.text}>花瓣官方账号</div>
          </div>
        </div>
      );
    }

    // 认证设计师
    if (user.extra?.is_museuser) {
      elements.push(
        <div className={styles.honor}>
          <Link href={`/muse/register`} passHref>
            <a className={styles.item}>
              <MuseTag
                user={user}
                size={20}
                className={styles.icon}
                textClassName={styles.text}
                title="认证设计师"
                withText
              />
            </a>
          </Link>
        </div>
      );
    }

    // job
    // if (jobName) {
    //   elements.push(<span>{jobName}</span>);
    // } else {
    //   if (isMe) {
    //     elements.push(
    //       <Link href={`/settings`} passHref>
    //         <a>职业未设置</a>
    //       </Link>
    //     );
    //   }
    // }

    // ip归属地
    const ipRegion = user?.last_login_geo?.geo?.region;
    if (ipRegion) {
      elements.push(`IP属地：${ipRegion}`);
    }

    return elements.reduce((prev, cur, idx) => {
      if (prev.length) {
        prev.push(<div className={styles.spliter} key={`${idx}_spliter`} />);
      }
      prev.push(
        <div className={styles.iconGroup} key={idx}>
          {cur}
        </div>
      );
      return prev;
    }, []);
  }, [isMe, isOfficial, jobName, user]);

  // 是否在特殊时期的敏感用户
  const isSensitive = useMemo(() => {
    return (
      isSpecialTime &&
      (user.pin_count <= 0 ||
        dayjs().isBefore(dayjs(parseInt(user.created_at * 1000)).add(3, "day")))
    );
  }, [user]);

  const displayUserName = useMemo(() => {
    if (isSensitive) {
      return username.slice(0, 1) + (username.length > 0 ? "**" : "");
    }

    return username;
  }, [isSensitive, username]);

  return (
    <div className={styles.summary}>
      <div className={styles.authorSummary}>
        <div className={styles.summaryBlock1}>
          {/* 头像 */}
          <div className={styles.avatar}>
            <If condition={isSensitive}>
              <Then>
                <UserAvatar
                  src={imageUrl(
                    {
                      bucket: "hbimg",
                      key: "654953460733026a7ef6e101404055627ad51784a95c-B6OFs4",
                      type: "image/jpeg",
                    },
                    { width: 180, rect: "sq" }
                  )}
                  user={user}
                  size="large"
                />
              </Then>
              <Else>
                <UserAvatar
                  src={
                    avatar_url || imageUrl(avatar, { width: 180, rect: "sq" })
                  }
                  user={user}
                  size="large"
                />
              </Else>
            </If>
          </div>

          <div className={styles.baseInfo}>
            {/* 昵称 */}
            <h1 className={styles.name}>
              <span>{displayUserName}</span>
            </h1>

            {/* 个人简介 */}
            <When condition={!isSensitive && user.profile?.about?.length}>
              <Tooltip title={user.profile?.about} placement="right">
                <div className={styles.about}>
                  {/* 将换行符替换为空格 */}
                  {user.profile?.about?.replace(/\n/g, " ")}
                </div>
              </Tooltip>
            </When>

            {/* 粉丝 * 关注 * 喜欢 */}
            <div className={styles.statistic}>
              <span
                onClick={() => setWin({ follower: true })}
                data-gd-click="button_click"
                data-button-name="粉丝"
              >
                {displayNum(follower_count)} 粉丝
              </span>
              &nbsp;·&nbsp;
              <Link href={`/user/${urlname}/following`}>
                <a data-gd-click="button_click" data-button-name="关注">
                  {displayNum(following_count)} 关注
                </a>
              </Link>
              &nbsp;·&nbsp;
              <Link href={`/user/${urlname}/likes`}>
                <a data-gd-click="button_click" data-button-name="喜欢">
                  {displayNum(likesCount)} 喜欢
                </a>
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.summaryBlock2}>
          <SummaryBlock2Elements />
        </div>

        <div className={styles.summaryBlock4}>
          <ShareDropdown
            placement="bottomCenter"
            pics={imageUrl(avatar, { width: 180, rect: "sq" })}
            title={`${displayUserName}的个人主页，已经有${displayNum(
              follower_count
            )}个用户在「花瓣网」关注了TA：`}
          >
            <HBButton
              className={styles.share}
              type={"text"}
              shape="circle"
              data-gd-click="button_click"
              data-button-name="分享"
            >
              <HBIcon type="hb_share_new" />
            </HBButton>
          </ShareDropdown>

          {isMe ? (
            <>
              <a
                data-gd-click="button_click"
                data-button-name="编辑个人资料"
                onClick={() => {
                  openSettingPage(user, {
                    page: "userInfo",
                  });
                }}
              >
                <HBButton> 编辑个人资料 </HBButton>
              </a>

              <Link href={`/space`}>
                <a data-gd-click="button_click" data-button-name="管理">
                  <HBButton> 管理 </HBButton>
                </a>
              </Link>
            </>
          ) : hasBlocked ? (
            <>
              {/* 已拉黑此用户 */}
              <Button
                type={"text"}
                onClick={onUnblockClick}
                data-gd-click="button_click"
                data-button-name="移出黑名单"
              >
                移出黑名单
              </Button>
            </>
          ) : (
            <>
              {/* 关注 */}
              {following ? (
                // <Button onClick={onUnfollowClick}>已关注</Button>
                <OperationButton
                  className={styles.operationButton}
                  onClick={onUnfollowClick}
                  data-gd-click="button_click"
                  data-button-name="取消关注"
                  data-concern-object-type="用户"
                  userInfo={user}
                ></OperationButton>
              ) : // <Button onClick={onUnfollowClick}>已关注</Button>
              isBlocked ? (
                <Tooltip
                  title="由于对方设置，你无法关注TA"
                  placement="bottom"
                  align={{ offset: [0, 10] }}
                >
                  <HBButton
                    type={"primary"}
                    onClick={onFollowClick}
                    disabled={isBlocked}
                    data-gd-click="button_click"
                    data-button-name="关注Ta"
                  >
                    关注
                  </HBButton>
                </Tooltip>
              ) : (
                <HBButton
                  type={"primary"}
                  onClick={onFollowClick}
                  data-gd-click="button_click"
                  data-button-name="关注Ta"
                >
                  关注
                </HBButton>
              )}

              {/* 私信 */}
              {isBlocked ? (
                <Tooltip
                  title="由于对方设置，你无法私信TA"
                  placement="bottom"
                  align={{ offset: [0, 10] }}
                >
                  <span>
                    {" "}
                    {/* span 单纯为了显示tooltip */}
                    <HBButton
                      onClick={onMessageClick}
                      disabled={isBlocked}
                      data-gd-click="button_click"
                      data-button-name="私信"
                    >
                      私信
                    </HBButton>
                  </span>
                </Tooltip>
              ) : (
                <HBButton
                  onClick={onMessageClick}
                  data-gd-click="button_click"
                  data-button-name="私信"
                >
                  私信
                </HBButton>
              )}

              {/* 举报 */}
              <Dropdown
                placement="bottomCenter"
                overlay={
                  <div className={styles.menu}>
                    <a
                      className={styles.menuItem}
                      onClick={onReportClick}
                      data-gd-click="button_click"
                      data-button-name="举报"
                      data-report-type="用户"
                      data-report-user-id={user_id}
                    >
                      <span className={styles.text}>举报</span>
                    </a>
                    <a
                      className={styles.menuItem}
                      onClick={onBlockClick}
                      data-gd-click="button_click"
                      data-button-name="加入黑名单"
                      data-report-type="用户"
                      data-report-user-id={user_id}
                    >
                      <span className={styles.text}>加入黑名单</span>
                    </a>
                  </div>
                }
              >
                <HBButton type={"text"} className={styles.more} shape="circle">
                  <HBIcon type={"ic_more"} />
                </HBButton>
              </Dropdown>
            </>
          )}
        </div>
      </div>

      {/* 粉丝列表 */}
      <FollowerModal
        visible={win.follower}
        urlname={urlname}
        onCancel={() => setWin({ ...win, follower: false })}
        destroyOnClose
      />

      {/* 私信 */}
      <ChatModal
        targetUserUrlname={urlname}
        visible={win.chat}
        onCancel={() => setWin({ ...win, chat: false })}
      />
    </div>
  );
}
